document.addEventListener("DOMContentLoaded", function() {
    // Reference the two wrapper elements
    var rightWrapper = document.querySelector('.pressNewsSection_filter_right__wrapper, .blog-grid-section_filter_right__wrapper');
    var leftWrapper = document.querySelector('.pressNewsSection_filter_left__wrapper, .blog-grid-section_filter_left__wrapper');

    // Function to toggle classes and ensure only one dropdown is open
    function handleDropdownToggle(clickedWrapper, otherWrapper) {
        if (clickedWrapper) {
            clickedWrapper.addEventListener('click', function(event) {
                // Prevent the event from bubbling up to the document when a wrapper is clicked
                event.stopPropagation();

                // Toggle the class for the clicked dropdown
                this.classList.toggle('collapse_filter'); 

                // If the other dropdown has the class, remove it
                if (otherWrapper && otherWrapper.classList.contains('collapse_filter')) {
                    otherWrapper.classList.remove('collapse_filter');
                }
            });
        }
    }

    // Remove the collapse_filter class when clicking outside of the wrappers
    document.addEventListener('click', function() {
        if (rightWrapper && rightWrapper.classList.contains('collapse_filter')) {
            rightWrapper.classList.remove('collapse_filter');
        }
        if (leftWrapper && leftWrapper.classList.contains('collapse_filter')) {
            leftWrapper.classList.remove('collapse_filter');
        }
    });

    // Attach event listeners to both wrappers
    handleDropdownToggle(rightWrapper, leftWrapper);
    handleDropdownToggle(leftWrapper, rightWrapper);
});






function updateSorting(count) {
    // Get the current timestamp (milliseconds since epoch)
    const timestamp = new Date().getTime();
  
    // Use the last 5 digits of the timestamp as the random number
    const randomFiveDigitNumber = Math.floor(timestamp % 100000);
    
    var newURL = window.location.origin + window.location.pathname + '?article_count=' + count + '&type=' + randomFiveDigitNumber;
    window.location.href = newURL;
  }
  
  function setSelectedOption() {
    var params = new URLSearchParams(window.location.search);
    var articleCount = params.get('article_count');
    var links = document.querySelectorAll('#blog_sorting_links a');
  
    // Get the element with class .pressNewsSection_filter_right__wrapper_select_label
    var label = document.querySelector('.pressNewsSection_filter_right__wrapper_select_label, .blog-grid-section_filter_right__wrapper_select_label');
  
    for (let i = 0; i < links.length; i++) {
      if (links[i].getAttribute('data-count') === articleCount) {
        links[i].classList.add('selected');
  
        label.textContent = 'Posts Per Page: ' + articleCount;
      } else {
        links[i].classList.remove('selected');
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', setSelectedOption);


  